import { GetApp, Pause } from '@mui/icons-material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import IconButton from '@mui/material/IconButton';
import Slider from '@mui/material/Slider';
import Typography from '@mui/material/Typography';
import throttle from 'lodash.throttle';
import { useEffect, useRef, useState } from 'react';

export default function AudioPlayer({ audio, type }) {
    const [duration, setDuration] = useState(0);
    const [time, setTime] = useState(0);

    const ref = useRef(null);

    const globalAudio = audio;

    const Source = () => (
        <source src={globalAudio} type={type || 'audio/mp3'} />
    );

    useEffect(() => {
        const audioRef = ref.current;
        const onSeeking = () => {};
        const onSeeked = () => {};
        const onDuration = () => setDuration(audioRef.duration);
        const onTime = throttle(() => {
            setTime(audioRef.currentTime);
        }, 250);

        audioRef.addEventListener('load', () => {
            alert('loadeds');
        });

        audioRef.addEventListener('durationchange', onDuration);
        audioRef.addEventListener('timeupdate', onTime);
        audioRef.addEventListener('seeking', onSeeking);
        audioRef.addEventListener('seeked', onSeeked);

        return () => {
            audioRef.removeEventListener('durationchange', onDuration);
            audioRef.removeEventListener('timeupdate', onTime);
            audioRef.removeEventListener('seeking', onSeeking);
            audioRef.removeEventListener('seeked', onSeeked);
        };
    }, [audio]);

    return (
        <Card
            variant="outlined"
            sx={{ width: '100%', bgcolor: 'background.default' }}
        >
            <CardContent>
                <audio ref={ref}>
                    <Source />
                    This browser does not support the HTML5 audio element.
                </audio>

                <Slider
                    min={0}
                    max={duration}
                    value={time}
                    onChange={(e, n) => {
                        ref.current.currentTime = n;
                    }}
                />

                <div className="d-flex align-items-center justify-content-between w-100">
                    <Typography>
                        <span className="me-2 fw-bold">
                            {Math.floor(time / 60)}:{Math.floor(time % 60)}
                        </span>
                        /
                        <span className="ms-2 fw-bold">
                            {Math.floor(duration / 60)}:
                            {Math.floor(duration % 60)}
                        </span>
                    </Typography>

                    <div className="d-flex align-items-center justify-content-between">
                        <IconButton
                            aria-label="play"
                            color="primary"
                            sx={{ mr: 1 }}
                            onClick={() => ref.current.play()}
                        >
                            <PlayArrowIcon />
                        </IconButton>
                        <IconButton
                            color="primary"
                            aria-label="pause"
                            sx={{ mr: 1 }}
                            onClick={() => ref.current.pause()}
                        >
                            <Pause />
                        </IconButton>
                        <IconButton
                            color="primary"
                            aria-label="download"
                            onClick={() => {
                                const anchor = document.createElement('a');
                                anchor.setAttribute('href', globalAudio);
                                anchor.click();
                            }}
                        >
                            <GetApp />
                        </IconButton>
                    </div>
                </div>
            </CardContent>
        </Card>
    );
}
